const PRIMARY_COLOR = "#136C62";
export const divaTheme = {
  primary: PRIMARY_COLOR,
  secondary: "#F2B531",
  lightGray: "#c1c2c2",
  darkGray: "#444444",
  black: "#040404",
  white: "#ffffff",
  circleButton: PRIMARY_COLOR,
  fontFamily: "Geist, sans-serif",
  breadCrumb: {
    color: PRIMARY_COLOR,
    hover: "#10423d",
  },
  hoverPrimaryClassButton: "theme-diva-primary-button",
  hoverSecondaryClassButton: "theme-secondary-button",
  hoverActionClassButton: "theme-diva-action-button",
  hoverLoginClassButton: "theme-diva-action-button",
  selected: {
    backgroundColor: "#22b5a3",
    afterBackgroundColor: PRIMARY_COLOR,
    hover: "#7bdbd5",
  },
  checkboxClass: "theme-diva-checkbox",
  fullSizeLogo: "../diva_mini_logo.svg",
  miniSizeLogo: "../diva_mini_logo.svg",
  loginBg: "../divaLogin.jpg",
  outlinedButtonClass: "theme-diva-outlined-button",
  borderClass: "border-diva",
  pageBrandInfoMargin: "150px 100px 0 90px !important",
  pageBrandInfoMarginMobile: "150px 100px 0 90px !important",
  brandImageBig: "/diva-login.png",
  brandImage: "/x.png",
  selectClass: "theme-diva-select",
  pageTitleColor: "#0b3a35",
  menuCategoryColor: "white",
  menuSideBarColor: PRIMARY_COLOR,
  sideSubMenuColor: "#105a52",
  activeLinkColor: "#0b3a35",
};
